import {
  Module,
  VuexModule,
  Mutation,
  Action,
} from 'vuex-module-decorators';

import {
  BASE_URL,
  GET_GAMES,
  GET_MAINTENANCE_GAMES,
  GET_TRANSACTIONS,
  EDIT_TRANSACTION,
  MAINTENANCE_GAME,
  GAME_UPDATE,
  M_POST,
  EDIT_DEMO_URL,
  GET_RISK_MANAGEMENT_LIST,
  UPDATE_CONFIGS_RISK, UPDATE_BALANCE_RISK, UPDATE_CANCEL_ROUND_RISK,
} from '@/utils/api';

import Vue from 'vue';
import { action } from '@storybook/addon-actions';

@Module({ name: 'game' })
export default class Game extends VuexModule {
  game: any = [];

  @Mutation
  mutateGame(game: any) {
    this.game = game;
  }

  @Action({ commit: 'mutateGame' })
  FetchGame(partner: object) {
    return Vue.axios({
      url: BASE_URL + GET_GAMES,
      method: M_POST,
      data: partner,
    })
      .then(({ data }) => {
        const { code, message } = data.status;
        if (code === 0) {
          const game = data.data;
          return game;
        } else {
          throw message;
        }
      })
      .catch((err) => err);
  }

  @Action({ commit: 'mutateGame' })
  FetchMaintenanceGame() {
    return Vue.axios({
      url: BASE_URL + GET_MAINTENANCE_GAMES,
      method: M_POST,
      data: {},
    })
      .then(({ data }) => {
        const { code, message } = data.status;
        if (code === 0) {
          const game = data.data;
          return game;
        } else {
          throw message;
        }
      })
      .catch((err) => err);
  }

  @Action
  MaintenanceGames(params) {
    return Vue.axios({
      url: BASE_URL + MAINTENANCE_GAME,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code, message } = data.status;
        if (code === 0) {
          return data.status;
        } else {
          throw message;
        }
      })
      .catch((err) => err);
  }

  @Action
  GameVersion(params) {
    return Vue.axios({
      url: BASE_URL + GAME_UPDATE,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code, message } = data.status;
        if (code === 0) {
          return data.status;
        } else {
          throw message;
        }
      })
      .catch((err) => err);
  }

  @Action
  EditDemoUrl(url) {
    return Vue.axios({
      url: BASE_URL + EDIT_DEMO_URL,
      data: url,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code, message } = data.status;
        if (code === 0) {
          return data.status;
        } else {
          throw message;
        }
      })
      .catch((err) => err);
  }

  @Action
  FetchVersionControl() {
    return Vue.axios({
      url: BASE_URL + GET_TRANSACTIONS,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code, message } = data.status;
        if (code === 0) {
          return data.data;
        } else {
          throw message;
        }
      })
      .catch((err) => err);
  }

  @Action
  EditVersion(_data) {
    return Vue.axios({
      url: BASE_URL + EDIT_TRANSACTION,
      data: _data,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code, message } = data.status;
        if (code === 0) {
          return data.status;
        } else {
          throw message;
        }
      })
      .catch((err) => err);
  }

  @Action
  FetchRiskManagementList(query) {
    return Vue.axios({
      url: BASE_URL + GET_RISK_MANAGEMENT_LIST,
      method: M_POST,
      data: query,
    })
      .then(({ data }) => {
        const { code, message } = data.status;
        if (code === 0) {
          // console.log(data.data);
          return data.data;
        } else {
          throw message;
        }
      })
      .catch((err) => err);
  }

  @Action
  UpdateRiskManagementConfigs(params) {
    return Vue.axios({
      url: BASE_URL + UPDATE_CONFIGS_RISK,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code, message } = data.status;
        if (code === 0) {
          return data.status;
        } else {
          throw message;
        }
      })
      .catch((err) => err);
  }

  @Action
  UpdateRiskBalance(params) {
    return Vue.axios({
      url: BASE_URL + UPDATE_BALANCE_RISK,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code, message } = data.status;
        if (code === 0) {
          return data.status;
        } else {
          throw message;
        }
      })
      .catch((err) => err);
  }

  @Action
  UpdateRiskCancelBet(params) {
    return Vue.axios({
      url: BASE_URL + UPDATE_CANCEL_ROUND_RISK,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code, message } = data.status;
        if (code === 0) {
          return data.status;
        } else {
          throw message;
        }
      })
      .catch((err) => err);
  }
}
